'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgFileAdd = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M13 18v-3h3v-2h-3v-3h-2v3H8v2h3v3h2Z" }),
  React__namespace.createElement("path", { fill: "#2D2E2E", d: "M20 6.59 15.41 2H4v20h16V10h-2v10H6V4h8v4h6V6.59Z" })
);

module.exports = SvgFileAdd;
//# sourceMappingURL=FileAdd.cjs.js.map
